module.exports = __webpack_public_path__ + "static/media/malahide.eddd8d32.png";